import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '../components/auth/AuthLayout'
import AppLayout from '../components/admin/AppLayout'
import multiguard from 'vue-router-multiguard'
import jwtClass from 'jsonwebtoken';
import store from '../store/index'

Vue.use(Router)

const EmptyParentComponent = {
  template: '<router-view></router-view>',
}

const checkAuth = (to, from, next) => {
    var jwt = $cookies.get("jwt");
    if(jwt && jwt != undefined){
      var now = parseInt(new Date().getTime() / 1000);
      store.commit("setAuth", {jwt : jwt, user: jwtClass.decode(jwt)});
      if(store.state.auth.user.role < 99 || now > jwtClass.decode(jwt).exp){
        next({name:'login'});
      }
    }else{
    	next({name:'login'});
    }
  next();
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: { name: 'orders' },
    },
    {
      path: '/auth',
      component: AuthLayout,
      children: [
        {
          name: 'login',
          path: 'login',
          component: () => import('../components/auth/login/Login.vue'),
        },
        {
          path: '',
          redirect: { name: 'login' },
        },
      ],
    },
    {
      name: 'Admin',
      path: '/admin',
      component: AppLayout,
      beforeEnter: multiguard([checkAuth]),
      children: [
        {
          name: 'orders',
          path: 'orders',
          component: () => import('../components/orders/index.vue')
        },
        {
          name: 'order',
          path: 'order/:uuid',
          component: () => import('../components/order/index.vue')
        },
        {
          name: 'catalog',
          path: 'catalog',
          component: EmptyParentComponent,
          children:[
            {
              name: 'categories',
              path: 'categories',
              component: () => import('../components/catalog/categories/index')
            },
            {
              name: 'category',
              path: 'category/:uuid',
              component: () => import('../components/catalog/categories/category')
            },
            {
              name: 'products',
              path: 'products',
              component: () => import('../components/catalog/products/index')
            },
            {
              name: 'product',
              path: 'product/:uuid',
              component: () => import('../components/catalog/products/product')
            },
          ]
        },
        {
          name: "payment-methods",
          path: "payment-methods",
          component: ()=> import ('../components/paymentMethods/index.vue') 
        },
        {
          name: "payment-method",
          path: "payment-method/:uuid",
          component: ()=> import ('../components/paymentMethod/index.vue') 
        },
        {
          name: "shipping-prices",
          path: "shipping-prices",
          component: ()=> import ('../components/shippingPrices/index.vue') 
        },
        {
          name: 'shipping-prices',
          path: 'shipping-prices/:uuid',
          component: () => import('../components/shippingPrice/index.vue')
        },
      ],
    },
  ],
})
